// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Zt_F","folio":"styles_folio__16Yqz"};